import { api } from '../api';
import type { InvitationAcceptance, operations } from '../types';

type ResendArgs = operations['createInvitationResend']['parameters']['path'];

/* istanbul ignore file */

export const invitationApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    acceptInvitation: builder.mutation<InvitationAcceptance, InvitationAcceptance>({
      query: (body) => ({
        url: 'api/invitation/',
        method: 'POST',
        body,
      }),
    }),

    resendInvitation: builder.mutation<void, ResendArgs>({
      query: ({ account_pk, invitation_pk }) => ({
        url: `api/account/${account_pk}/invitation/${invitation_pk}/resend/`,
        method: 'POST',
      }),
    }),
  }),
});
